import { Modal } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useState } from "react";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";

import "./inventory-list-page-style.scss";
import CustomButton from "../kits/button/CustomButton";

export default function FilterBillModal({
  show,
  setShow,
  proDebounce,
  userDebounce,
  productItem,
  showCategory,
  formValues,
  handleChangeProperties,
  handleChangePropertiesّInput,
  handelChangeSelect,
  handelChangeInput,
  productHandeler,
  userItem,
  configItem,
}) {
  // state for maping properties
  const [selectedFilterOptions, setSelectedFilterOptions] = useState({});
  return (
    <Modal show={show} onHide={setShow} contentClassName="filter-bill-modal">
      <Modal.Header closeButton>فیلتر قبض</Modal.Header>
      <Modal.Body className="d-flex flex-wrap">
        <div className="mt-2 px-1 col-3">
          <ReactSelect
            title="نوع قبض"
            itemsList={[
              { value: 1, label: "خروجی" },
              { value: 2, label: "ورودی" },
            ]}
            inputValue={""}
            onChangeFunc={(e) => {}}
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="mt-2 px-1 col-9">
          <ReactSelect
            title="انتخاب محصول"
            inputValue={formValues.productFilter}
            itemsList={productItem.dataPro.selectItem}
            onInputChangeFunc={(e) => {
              proDebounce(e);
            }}
            onChangeFunc={(e) => {
              productHandeler(
                e,
                "dataFilter",
                productItem.dataPro.propertiesItem,
                handelChangeSelect,
                "productFilter"
              );
            }}
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        {showCategory.dataFilter.length > 0 && (
          <div className="w-100 d-flex flex-wrap border rounded shadow py-2 px-1">
            <span className="w-100" style={{ fontSize: 12 }}>
              صفات محصول
            </span>
            {showCategory?.dataFilter?.map((data) => {
              if (data.type == 1) {
                return (
                  <div className="px-1 mt-2 col-6">
                    <CustomInput
                      key={data.property_id}
                      label={data.title}
                      inputSize="same-as-select"
                      type="text"
                      inputContainer=""
                      inputValue={selectedFilterOptions[data.property_id]}
                      onChangeFunc={(e) => {
                        if(!isNaN(e.target.value)){

                          handleChangePropertiesّInput(data.property_id,e.target.value,setSelectedFilterOptions)
                        }
                      }}
                    />
                  </div>
                );
              } else if (data.type == 2) {
                const options = data.options.split(",").map((option) => ({
                  value: option,
                  label: option,
                }));

                return (
                  <div className="px-1 mt-2 col-6">
                    <ReactSelect
                      key={data.property_id}
                      title={data.title}
                      itemsList={options}
                      inputValue={selectedFilterOptions[data.property_id]}
                      onChangeFunc={(selectedOption) =>
                        handleChangeProperties(
                           data.property_id,
                           selectedOption,
                           setSelectedFilterOptions
                           )
                      }
                      placeholder="..."
                      inputSize="same-as-select"
                    ></ReactSelect>
                  </div>
                );
              }
            })}
          </div>
        )}
        <div className="col-6 mt-2 px-1 form-label-custom">
          <label className="form-label-custom" style={{ marginBottom: 8 }}>
            تاریخ ورود
          </label>

          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginLeft: "5px" }}>از</span>
            <DatePicker
              value={""}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {}}
            />
            <span style={{ margin: "0 5px" }}>تا</span>
            <DatePicker
              value={""}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {}}
            />
          </div>
        </div>
        <div className="col-6 mt-2 px-1 form-label-custom">
          <label className="form-label-custom" style={{ marginBottom: 8 }}>
            تاریخ ثبت
          </label>

          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginLeft: "5px" }}>از</span>
            <DatePicker
              value={""}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {}}
            />
            <span style={{ margin: "0 5px" }}>تا</span>
            <DatePicker
              value={""}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {}}
            />
          </div>
        </div>

        <div className="mt-2 px-1 col-6">
          <ReactSelect
            title="کاربر تحویل گیرنده"
            itemsList={userItem.dataUser}
            inputValue={formValues.userReceiveFilter}
            onChangeFunc={(e) => {
              handelChangeSelect(e,"userReceiveFilter")
            }}
            onInputChangeFunc={(e)=>{
              userDebounce(e)
            }}
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="mt-2 px-1 col-6">
          <ReactSelect
            title="کاربر تحویل دهنده"
            itemsList={userItem.dataUser}
            inputValue={formValues.userSendFilter}
            onChangeFunc={(e) => {
              handelChangeSelect(e,"userSendFilter")
            }}
            onInputChangeFunc={(e)=>{
              userDebounce(e)
            }}
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="mt-2 px-1 col-4">
          <ReactSelect
            title="نوع انبار"
            itemsList={configItem.dataRepository}
            inputValue={formValues.repositoryFilter}
            onChangeFunc={(e) => {
              handelChangeSelect(e,"repositoryFilter")
            }}
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="col-8 mt-2 px-1 form-label-custom">
          <label className="form-label-custom mt-1" style={{ marginBottom: 8 }}>
            موجودی
          </label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginLeft: "5px" }}>از</span>
            <CustomInput
              id="titleTour"
              inputSize="same-as-select"
              type="text"
              inputContainer=""
              inputValue={formValues.num2}
              textErr={""}
              onChangeFunc={(e) => {
                if(!isNaN(e.target.value)){

                  handelChangeInput(e.target.value,"num2")
                }
              }}
            />
            <span style={{ margin: "0 5px" }}>تا</span>
            <CustomInput
              id="titleTour"
              inputSize="same-as-select"
              type="text"
              inputContainer=""
              inputValue={formValues.num1}
              textErr={""}
              onChangeFunc={(e) => {
                if(!isNaN(e.target.value)){

                  handelChangeInput(e.target.value,"num1")
                }
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3 w-100">
          <CustomButton
            size="medium "
            className=""
            onClick={() => {}}
            color="success"
          >
            فیلتر
          </CustomButton>{" "}
        </div>
      </Modal.Body>
    </Modal>
  );
}
